<template>
  <v-card
    class="flex-col-start-start px-4 py-2"
    style="position: relative"
    min-height="330px"
  >
    <div class="flex-row-between-start w-100">
      <div>
        <div class="text-subtitle-2 tableText--text">{{ $t("view") }}:</div>
        <div class="flex-row-start-center gap-2">
          <div class="text-subtitle-2">{{ $t("fromDate") }}</div>
          <v-text-field
            dense
            solo
            flat
            readonly
            :value="from"
            id="hmi-history-from"
            class="date-input"
            background-color="background"
            :disabled="loading"
            :loading="loading"
            @click="fromDatePicker = true"
          />
          <aironpax-date-picker
            custom-input="#hmi-history-from"
            :value="from"
            :show="fromDatePicker"
            @close="fromDatePicker = false"
            @change="onDateChange($event, 'from')"
          />
          <div class="text-subtitle-2">{{ $t("toDate") }}</div>
          <v-text-field
            dense
            solo
            flat
            readonly
            :value="to"
            id="hmi-history-to"
            class="date-input"
            background-color="background"
            :disabled="loading"
            :loading="loading"
            @click="toDatePicker = true"
          />
          <aironpax-date-picker
            custom-input="#hmi-history-to"
            :value="to"
            :show="toDatePicker"
            @close="toDatePicker = false"
            @change="onDateChange($event, 'to')"
          />
        </div>
      </div>
      <div>
        <div class="text-subtitle-2 tableText--text">
          {{ $t("parameter") }}:
        </div>
        <v-chip-group
          :value="parameters.indexOf(selectedParam)"
          @change="onParamChange"
          class="interval-chips"
          mandatory
          column
        >
          <v-chip
            v-for="param in parameters"
            :key="param"
            class="direction-ltr"
            active-class="active-interval"
            :disabled="loading"
            x-small
          >
            {{ $t(param) }}
          </v-chip>
        </v-chip-group>
      </div>
    </div>
    <div class="w-100">
      <HMIChart />
    </div>
    <HMIHistoryExport :type="type" />
  </v-card>
</template>

<script>
import {
  CREATE_HMI_CHART,
  UPDATE_HMI_CHART_CONFIG,
} from "@/core/services/store/modules/hmi/hmi.module";
import moment from "jalali-moment";
import { mapGetters } from "vuex";
import HMIChart from "./HMIChart.vue";
import HMIHistoryExport from "./HMIHistoryExport.vue";
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";

export default {
  name: "HMIHistory",

  props: {
    type: { type: String, required: true },
  },

  data() {
    return {
      loading: false,
      fromDatePicker: false,
      toDatePicker: false,
      parameters: ["carbon", "metallization", "production_rate"],
    };
  },

  computed: {
    ...mapGetters(["HMIChartConfig"]),
    from() {
      return moment(this.HMIChartConfig.from).format("jYYYY/jMM/jDD");
    },
    to() {
      return moment(this.HMIChartConfig.to).format("jYYYY/jMM/jDD");
    },
    selectedParam() {
      return this.HMIChartConfig.parameter;
    },
  },

  created() {
    this.createChartData();
  },

  methods: {
    onDateChange(date, key) {
      this.$store.commit(UPDATE_HMI_CHART_CONFIG, {
        [key]: new Date(date),
      });
      this.createChartData();
    },
    onParamChange(paramIndex) {
      this.$store.commit(UPDATE_HMI_CHART_CONFIG, {
        parameter: this.parameters[paramIndex],
      });
      this.createChartData();
    },
    async createChartData() {
      this.loading = true;
      await this.$store
        .dispatch(CREATE_HMI_CHART, this.type)
        .then()
        .catch((error) => {
          this.$store.commit(SET_ALERT, {
            text: error.message,
            isError: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  components: {
    HMIChart,
    HMIHistoryExport,
  },
};
</script>

<style lang="scss">
.date-input {
  border: 1px solid var(--v-lightGrey-base);
  direction: ltr !important;
  width: 75px;
  & .v-input__control {
    min-height: 20px !important;
    max-height: 20px !important;
  }
  & .v-text-field__details {
    display: none;
  }
  & .v-input__slot {
    background-color: var(--v-background-base) !important;
    padding: 0 4px !important;
    margin: 0 !important;
    min-height: 20px !important;
    max-height: 20px !important;
    border-radius: 2px !important;
  }
  & input {
    height: 20px;
    max-height: 20px !important;
    font-size: 12px;
    direction: ltr;
  }
}
.interval-chips {
  & .v-slide-group__content {
    padding: 0 !important;
    gap: 5px;
  }
  & .v-chip {
    margin-inline: 0 !important;
  }
}
.active-interval {
  color: white !important;
  background-color: var(--v-mainBlue-base) !important;
}
</style>
